module.exports = __webpack_public_path__ + "img/card-unchecked.d833a664.svg";